import { render, staticRenderFns } from "./UcFileIcon.yaml?vue&type=template&id=1ea3416b&component"
import script from "./UcFileIcon.yaml?vue&type=script&lang=ts&component"
export * from "./UcFileIcon.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports